import { createModel } from '@rematch/core';
import global from 'global';
import { basename } from 'utils/custom-router';
import request, { history } from 'request';
import { createBrowserHistory } from 'history';

const initialValue: global.contextApplication = {
	data: null,
	manual_factors: null,
	guarantor_factors: null,
};



const application = createModel()({
	state: initialValue as global.contextApplication,
	reducers: {
		SET(state, payload: any) {
			let application: global.application = payload.application ?? payload;
			let manual_factors: global.manual_factors = payload.manual_factors ?? null;
			let guarantor_factors: global.guarantor_factors[] = payload.guarantor_factors ?? null;
			if (JSON.stringify(state.data) === JSON.stringify(application)) return state;
			else {
				return {
					...state,
					data: { ...application },
					manual_factors: { ...manual_factors },
					guarantor_factors: guarantor_factors,
				};
			}
		},
		REMOVE() {
			return initialValue;
		},
	},
	effects: (dispatch) => ({
		async FETCH_APPLICATION_BY_ID({ id, onEnd }: { id?: string | number; onEnd?: () => void }) {
			const response = await request
				.get('applications/' + id)
				.catch((e) => e.response?.status === 404 && history.push(`/login`));
			if (!response) return;
			const data = await response.data;
			dispatch.application.SET(data);
			onEnd?.();
		},
		async FETCH_APPLICATION_BY_ID_NO_PENDING(id) {
			const response = await request.get('applications/' + id);
			const data = await response.data;
			dispatch.application.SET(data);
		},
	}),
});

export default application;
